export default __webpack_public_path__ + "static/media/brave_zone_background_m1.d8265647.jpg";